<div class="form-floating" ngbDropdown>
  <input
    [ngModel]="selectedOption?.value"
    name="meansOfTransport"
    id="meansOfTransport"
    type="hidden"
  />
  <button
    #toggle
    aria-haspopup="listbox"
    (keydown)="setFocus($event)"
    aria-labelledby="customSelectLabel"
    class="form-select custom-select text-start no-toggle-arrow"
    ngbDropdownToggle
    type="button"
  >
    <span *ngIf="selectedOption" aria-hidden="true">{{ selectedOption.label }}</span>
  </button>
  <label class="form-label" id="customSelectLabel" for="meansOfTransport">
    Floatinglabel custom-select {{ infoText }}
  </label>
  <div aria-labelledby="customSelectLabel" class="w-100 mw-100" ngbDropdownMenu role="listbox">
    <button
      (click)="toggle.focus()"
      (focus)="selectedOption = option"
      *ngFor="let option of options"
      [attr.aria-selected]="selectedOption?.value === option.value"
      [class.active]="selectedOption?.value === option.value"
      class="d-flex align-items-center"
      ngbDropdownItem
      role="option"
      type="button"
      #option
    >
      <em aria-hidden="true" class="pi me-small-regular" [class]="'pi-' + option.icon"></em>
      <span>{{ option.label }}</span>
    </button>
  </div>
</div>
